import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="grid grid-cols-1 gap-3">
      {[...Array(7)].map((_, index) => {
        const width1 = `${Math.floor(Math.random() * (100 - 60) + 60)}px`;
        const width2 = `${Math.floor(Math.random() * (140 - 80) + 80)}px`;

        return (
          <div key={index} className="flex items-center p-3 bg-gray-100 rounded-[18px] cursor-pointer animate-pulse">
            <div className="bg-gray-300 h-[50px] w-[50px] rounded-full"></div>
            <div className="ml-3 space-y-2">
              <div className="bg-gray-300 h-[12px] rounded" style={{ width: width1 }}></div>
              <div className="bg-gray-300 h-[10px] rounded" style={{ width: width2 }}></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SkeletonLoader;
